const images = {
    logo: require('./logo.png'),
};

export default images;
